import AccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';

export const StyledAccordionSummary = styled(AccordionSummary)`
  background-color: #f7f7f7;
`;